import { ArticleCard, type ArticleCardData } from '../../home/components/ArticleCard';

export function RelatedNews({ items }: { items: ArticleCardData[] }) {
  if (items.length === 0) return null;
  return (
    <section className="latest-news-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h3 className="title">المزيد من الأخبار</h3>
            </div>
          </div>
        </div>
        <div className="row">
          {items.map((it) => (
            <div className="col-lg-4" key={it.id}>
              <ArticleCard card={it} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
